var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMileagewhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 4.5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FAFAFA",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.398 5.525a3.375 3.375 0 00-2.59-1.216c-1.883 0-3.41 1.559-3.41 3.481 0 .991.406 1.886 1.057 2.52",
    stroke: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FAFAFA",
    cx: 8,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    d: "M8 8l3.306-3.306"
  }))));
}

export default SvgMileagewhite;